import { motion } from "framer-motion";

const links = [
  { label: "Identity", href: "#about" },
  { label: "Practice", href: "#practice" },
  { label: "Vision", href: "#vision" },
  { label: "Connect", href: "#contact" },
];

export default function Header() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-40"
      style={{ mixBlendMode: "difference" }}
      data-testid="site-header"
    >
      <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 xl:px-24 py-6 md:py-8 flex items-center justify-between">
        <a
          href="#hero"
          className="flex items-center gap-3"
          data-testid="logo-link"
        >
          <div className="w-2 h-2 bg-[#d4ff00] rounded-full" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-white">
            Ziraminds / AI
          </span>
        </a>

        <nav
          className="hidden md:flex items-center gap-10"
          data-testid="primary-nav"
        >
          {links.map((l, i) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.25em] text-white link-underline"
            >
              <span className="text-[#8a8a8a] mr-2">0{i + 1}</span>
              {l.label}
            </a>
          ))}
        </nav>

        <div
          className="hidden md:flex items-center gap-3"
          data-testid="header-status"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#d4ff00] animate-pulse" />
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white">
            Building / In Public
          </span>
        </div>
      </div>
    </motion.header>
  );
}
